import React from 'react';
import './ContactSection.css';
import { Link } from 'react-router-dom';

function ContactSection() {
    return (
        <div className="contact-wrapper">
          <div className="contact-content">
            <p>London • Remote</p>  
          </div>
          <Link to="/contact" className="contact-section__contact-btn">
            Contact
          </Link>
          <div className="contact-socials">
            <a
              href="https://instagram.com/__venusianrose/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
            >
              <img src="/icons/instagram.svg" alt="" />
            </a>

            <a
              href="https://estefaniamorton.substack.com/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Substack"
            >
              <img src="/icons/substack.svg" alt="" />
            </a>
          </div>
        </div>
      );
}

export default ContactSection;
